import { DeviceUUID } from 'main/vendor/device-uuid';
import { UAParser } from 'ua-parser-js';

import {
  browserAnalyticsTrafficContext,
  browserReleaseVersion,
  browserShouldUseCrawlerRendering,
} from './traffic-policy';

// eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion -- legacy JS constructor lacks a construct signature.
const DeviceUuid = DeviceUUID as unknown as new () => { get: () => string };

export const DEVICE_INFO = UAParser();
export const DEVICE_UUID = new DeviceUuid().get();

export const ANALYTICS_TRAFFIC = browserAnalyticsTrafficContext();
export const CRAWLER_RENDERING = browserShouldUseCrawlerRendering();
export const ANALYTICS_DISABLED = !ANALYTICS_TRAFFIC.enabled;
export const RELEASE_VERSION = browserReleaseVersion();
export const PRERENDER_RENDERING = /prerender/i.test(window?.navigator?.userAgent);
